<template>
    <div>
      <div class="jumbotron">
        <h1>Comment utilisons-nous les cookies ?</h1>
        <h4>Retrouvez ici toutes les informations sur pourquoi et comment nous utilisons les cookies chez lookeoo</h4>
      </div>
      
      <div class="container">
        <p>Nous utilisons les cookies afin de fournir les services et fonctionnalités proposés sur notre site et afin d’améliorer l’expérience de nos utilisateurs. Les cookies sont des données qui sont téléchargés ou stockés sur votre ordinateur ou sur tout autre appareil.</p>
        <p>En cliquant sur ”J’accepte”, vous acceptez l’utilisation des cookies. Vous pourrez toujours les désactiver ultérieurement. Si vous supprimez ou désactivez nos cookies, vous pourriez rencontrer des interruptions ou des problèmes d’accès au site.</p>
        <p>En poursuivant votre navigation, vous acceptez le dépôt de cookies tiers destinés à vous proposer des vidéos, des boutons de partage, des remontées de contenus de plateformes sociales.</p>
        <p>Nous utilisons des cookies pour nous permettre de mieux comprendre comment le site est utilisé. En continuant à utiliser ce site, vous acceptez cette politique.</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CookiesPage'
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/CookiesPage.vue